import React from 'react';

import { ClockIcon, SnapshotInfoIcon, TruckIcon } from 'features/order-tracker/shared-components/svg';

import { DELIVERY } from '../../constants';
import { SERVICE_INFO } from './constants';

import styles from './styles.module.scss';

export const ServiceInfoComponent: React.FC<components.ServiceComponents> = ({
  type,
  totalCount,
  completedCount,
  error = false,
}) => {
  const getMessage = (): React.ReactNode => {
    if (!completedCount) {
      return (
        <p>
          {totalCount} {SERVICE_INFO[type].item}
          {totalCount > 1 ? 's' : ''} {SERVICE_INFO[type].toDo}
        </p>
      );
    }

    if (totalCount === 1) {
      return (
        <p>
          1 {SERVICE_INFO[type].item} {SERVICE_INFO[type].done}
        </p>
      );
    }

    return (
      <p>
        {completedCount} out of {totalCount} {SERVICE_INFO[type].item}s {SERVICE_INFO[type].done}
      </p>
    );
  };

  if (error) {
    return (
      <div className={styles.errorItem}>
        <SnapshotInfoIcon className={styles.icon} />
        Awaiting delivery details
      </div>
    );
  }

  if (!totalCount) {
    return null;
  }

  const ServiceIcon = type === DELIVERY ? TruckIcon : ClockIcon;

  return (
    <div className={styles.serviceInfoContainer}>
      <div className={styles.title}>
        <ServiceIcon className={styles.icon} />
        <h5>{SERVICE_INFO[type].title}</h5>
      </div>
      <div id={SERVICE_INFO[type].id}>{getMessage()}</div>
    </div>
  );
};
